import { render, staticRenderFns } from "./RelatedLinks.vue?vue&type=template&id=2121ed58"
import script from "./RelatedLinks.vue?vue&type=script&lang=js"
export * from "./RelatedLinks.vue?vue&type=script&lang=js"
import style0 from "./RelatedLinks.vue?vue&type=style&index=0&id=2121ed58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports